import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemTypeStoredIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.19 12.92L18.16 9.99V4.14C18.16 3.87 18.02 3.63 17.79 3.49L12.38 0.349995C12.15 0.209995 11.86 0.209995 11.63 0.349995L6.22 3.49C5.99 3.62 5.85 3.87 5.85 4.14V9.99L0.810002 12.92C0.580002 13.05 0.440002 13.3 0.440002 13.57V19.86C0.440002 20.13 0.580002 20.37 0.810002 20.51L6.22 23.65C6.45 23.79 6.74 23.79 6.97 23.65L12 20.73L17.03 23.65C17.26 23.79 17.55 23.79 17.78 23.65L23.18 20.51C23.41 20.38 23.55 20.13 23.55 19.86V13.57C23.55 13.3 23.41 13.06 23.18 12.92H23.19ZM17.41 15.99L13.33 13.66L17.41 11.29L21.48 13.66L17.41 15.99ZM11.38 7.65V12.34L7.35 10V5.35L11.38 7.65ZM16.66 10L12.63 12.34V7.65L16.66 5.35V10ZM6.59 11.3L10.67 13.67L6.59 16L2.51 13.67L6.59 11.3ZM7.22 17.08L11.25 14.78V19.43L7.22 21.77V17.08ZM12 1.87L16.08 4.24L12 6.57L7.92 4.24L12 1.87ZM1.94 14.77L5.97 17.07V21.76L1.94 19.42V14.77ZM12.75 14.77L16.78 17.07V21.76L12.75 19.42V14.77ZM18.03 21.77V17.08L22.06 14.78V19.43L18.03 21.77Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemTypeStoredIcon.displayName = 'ItemTypeStoredIcon';
